import { bcDateFormats } from './../common/constants/date-formats';
import { bcEnums } from './../common/constants/boldchat-enums';
import { WorkItemAdapter } from 'common/workitems/workitem-adapter';
import { Injectable } from '@angular/core';
import { BcRestApi } from 'common/api/rest-api';
import * as moment from 'moment';

@Injectable()
export class SearchService {
  constructor(private bcRestApi: BcRestApi) { }

  search(searchParams) {
    const bodyParams = this._getBodyParams(searchParams);
    return this.bcRestApi.search(bodyParams).then(data => data.results.map(searchItem => WorkItemAdapter.createFromSearch(searchItem)));
  }

  _getBodyParams(searchParams) {
    this._decorateSearchParams(searchParams);

    return {
      startDate: searchParams.startDate,
      endDate: searchParams.endDate,
      keywords: searchParams.searchQuery,
      serviceTypes: searchParams.serviceTypes,
      departmentId: searchParams.departmentId,
      operatorId: searchParams.operatorId
    };
  }

  _decorateSearchParams(searchParams) {
    // Default service types to ALL if not set
    if (!searchParams.serviceTypes || searchParams.serviceTypes.length === 0) {
      searchParams.serviceTypes = [bcEnums.services.ALL]; // Search over all service types
    }

    // Default startDate to 7 days (168 hours) ago if not set
    if (!searchParams.startDate) {
      searchParams.startDate = moment().add(-168, 'hours').utc().format(bcDateFormats.API_DATE_FORMAT);
    }

    // Default endDate to now if not set
    if (!searchParams.endDate) {
      searchParams.endDate = moment().utc().format(bcDateFormats.API_DATE_FORMAT);
    }
  }
}
